import dateFormat from "dateformat";
import { orderBy, where } from 'firebase/firestore';
import React, { useContext, useEffect, useMemo, useState } from 'react';
import { DefaultContext } from '../../../contexts/default';
import InsumosHistoryDB from '../../../database/wrappers/insumosHistory';
import Money from '../../../helpers/utils/money/money';
import TableCustom from '../../MyCustom/TableCustom';
import Modal, { ModalBody, ModalHeader, ModalTitle } from '../../bootstrap/Modal';
import { convertGramaToKg, getFloatCMV } from "../../../utils/cmv/convertQtd";

const ModalHistoricoInsumos = ({ open, handleOpen, insumoSelected }) => {
    const { estabSelected, storeSelected } = useContext(DefaultContext);

    const [insumeHistory, setInsumeHistory] = useState([])

    useEffect(() => {
        if (!estabSelected || !storeSelected || !insumoSelected?.id) {
            setInsumeHistory([])
            return;
        };
        const onInsumos = new InsumosHistoryDB(estabSelected, storeSelected)
            .on(
                setInsumeHistory,
                orderBy('type'),
                orderBy('created_at', 'desc'),
                where('insumeId', '==', insumoSelected.id),
                where('type', '==', 'entry'),
            );

        return () => {
            onInsumos()
        }
    }, [insumoSelected])

    const columns = useMemo(() => [
        {
            label: 'Data',
            field: 'created_at',
            format: row => row.created_at ? dateFormat(row.created_at.seconds * 1000, 'dd/mm/yyyy') : '',
            formatExport: value => value ? dateFormat(value.seconds * 1000, 'dd/mm/yyyy') : '',
        },
        {
            label: 'Unidade',
            field: 'unit',
        },
        {
            label: "Quantidade",
            field: "{row}",
            format: row => getFloatCMV(row.qtd),
            formatExport: row => getFloatCMV(row.qtd)
        },
        {
            label: 'Preço Unitario',
            field: 'price',
            format: row => Money.centsToMaskMoney(row.price),
            formatExport: value => Money.centsToCoinCsv(value),
        },
        {
            label: 'Preço Total',
            field: "{row}",
            format: row => Money.centsToMaskMoney(row.price * row.qtd),
            formatExport: row => Money.centsToCoinCsv(row.price * row.qtd),
        },
    ], [])

    return (
        <Modal
            isOpen={open}
            setIsOpen={handleOpen}
            isStaticBackdrop
            isScrollable={false}
            isCentered
            size="lg"
            isAnimation
        >
            <ModalHeader className="p-4 mt-2 justify-content-start" setIsOpen={handleOpen}>
                <ModalTitle>
                    {'Historico de insumo'}
                </ModalTitle>
            </ModalHeader>
            <ModalBody className="p-5">
                <TableCustom
                    titlePdf='Historico de insumo'
                    icon='TableChart'
                    fontSize={8}
                    rows={insumeHistory}
                    columns={columns}
                    fileName={'Historico de insumo'}
                />
            </ModalBody>
        </Modal>
    )
}

export default ModalHistoricoInsumos